import React from "react";

import Input from "../../../components/Input";

/**
 * Dimensões e peso do produto (BDM-887).
 *
 * São dados de FRETE — cotação, etiqueta, volume da nota —, por isso vivem
 * numa seção própria e não junto do fiscal: quem preenche costuma ser quem
 * embala, com a régua na mão.
 *
 * As unidades acompanham o resto do sistema (a API de fornecedor já recebe
 * assim): **milímetros** e **gramas**, sempre inteiros. Guardar em inteiro
 * evita o arredondamento que apareceria somando 300 itens de 0,35 kg.
 */
export const ProductShippingTab = ({
    height,
    setHeight,
    width,
    setWidth,
    depth,
    setDepth,
    diameter,
    setDiameter,
    weight,
    setWeight,
    netWeight,
    setNetWeight,
}) => {
    // Campo de medida: só dígitos, e vazio continua vazio (não vira zero):
    // vazio é "não informado", e o backend recusa 0 (BDM-1299).
    const onlyDigits = value => (value ?? '').toString().replace(/\D/g, '');

    return (
        <div className="product-shipping-tab">
            <div className="row">
                <div className="col-6">
                    <h2 className="section-title">Informações de frete</h2>

                    <div className="row">
                        <div className="col-4">
                            <Input
                                label={`Altura (mm)`}
                                value={height}
                                change={value => setHeight(onlyDigits(value))}
                            />
                        </div>
                        <div className="col-4">
                            <Input
                                label={`Largura (mm)`}
                                value={width}
                                change={value => setWidth(onlyDigits(value))}
                            />
                        </div>
                        <div className="col-4">
                            <Input
                                label={`Profundidade (mm)`}
                                value={depth}
                                change={value => setDepth(onlyDigits(value))}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-4">
                            <Input
                                label={`Diâmetro (mm)`}
                                value={diameter}
                                change={value => setDiameter(onlyDigits(value))}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <Input
                                label={`Peso bruto (g)`}
                                value={weight}
                                change={value => setWeight(onlyDigits(value))}
                            />
                        </div>
                        <div className="col-6">
                            <Input
                                label={`Peso líquido (g)`}
                                value={netWeight}
                                change={value => setNetWeight(onlyDigits(value))}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductShippingTab;
